// @flow
import type {FooterConfig} from '@travel-frontend/ui-components';
import type {StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';
import {Footer as UIFooter} from '@travel-frontend/ui-components';

import {Container} from 'components/Layout/components/Footer/components/Container';

type Props = {
  config?: FooterConfig,
  kind: 'full' | 'shortWithLinks' | 'short',
};

export const Footer: StatelessFunctionalComponent<Props> = styled(
  ({config, kind = 'shortWithLinks'}: Props) => (
    <Container>
      <UIFooter config={config} kind={kind} />
    </Container>
  )
)``;
